import React, { FC } from 'react';
import classNames from 'classnames';
import { Icon, IconNames } from '@whitesharx/starfall-frontend-ui-kit';
import type { MoveGrade } from '@whitesharx/starfall-frontend-chessground';
import {
  containerStyles,
  figureStyles,
  sanStyles,
  sanWithFigureStyles,
  selectedColorDefaultStyles,
  selectedColorStyles,
} from './styles.css';

type Figure = 'N' | 'B' | 'R' | 'Q' | 'K';

const FIGURE_MAPPING: Record<Figure, (color: 'w' | 'b') => IconNames> = {
  N: (color) => (color === 'w' ? 'knightWhite' : 'knightBlack'),
  B: (color) => (color === 'w' ? 'bishopWhite' : 'bishopBlack'),
  R: (color) => (color === 'w' ? 'rookWhite' : 'rookBlack'),
  Q: (color) => (color === 'w' ? 'queenWhite' : 'queenBlack'),
  K: (color) => (color === 'w' ? 'kingWhite' : 'kingBlack'),
};

type Props = {
  value: string;
  color: 'w' | 'b';
  selected?: boolean;
  grade?: MoveGrade;
  onClick: () => void;
  className?: string;
};

const SAN: FC<Props> = ({ value, color, grade, selected, className, onClick }) => {
  const getSelectedStyles = () => {
    if (!selected) {
      return null;
    }

    if (selected && !grade) {
      return selectedColorDefaultStyles;
    }

    if (selected && grade) {
      return selectedColorStyles[grade] || selectedColorDefaultStyles;
    }
  };

  const formatSan = (value: string, color: 'w' | 'b') => {
    const figure = value[0];

    const styles = classNames(sanStyles, className, getSelectedStyles());

    if (figure in FIGURE_MAPPING) {
      value = value.replace(figure, '').replace(/^x/, '');
      const iconName = FIGURE_MAPPING[figure as Figure](color);

      return (
        <span className={classNames(styles, sanWithFigureStyles)}>
          <Icon name={iconName} className={figureStyles} size="18px" />
          {value}
        </span>
      );
    }

    return <span className={styles}>{value}</span>;
  };

  return (
    <span className={containerStyles} onClick={onClick}>
      {formatSan(value, color)}
    </span>
  );
};

export default SAN;
